<template>
    <div>
    <span class="badge badge-pill bg-secondary" :style="fieldColor">{{fieldValue}}</span>
    </div>
</template>

<script>

    import TableUtil from "../utils/TableUtil";

    export default {
        name: 'SelectView',
        props: ['field', 'document'],
        computed: {
            fieldColor() {
                if(this.document && this.document[this.field.index]) {
                    let tableUtil = new TableUtil()
                    let colorValue = tableUtil.getFieldColor(this.field, this.document[this.field.index])
                    return 'background-color: ' + colorValue + ' !important;'
                }

                return ''
            },
            fieldValue() {
                return this.document ? this.document[this.field.index] : 'Field: ' + this.field.name
            }
        }
    }
</script>

<style>

</style>
